// for tab toggle
document.querySelectorAll('.tab').forEach(tab => {
    tab.addEventListener('click', () => {
        // Deactivate all tabs
        document.querySelectorAll('.tab').forEach(tab => {
            tab.classList.remove('active');
        });
        tab.classList.add('active');

        const clickedTabIndex = Array.from(tab.closest('.tab-title').children).indexOf(tab);
        document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
        document.querySelectorAll('.tab-content')[clickedTabIndex].classList.add('active');
    });
});

document.querySelector('.tab:first-child').click();
